// @flow
import $ from 'jquery';
import EdeeshopPopup from 'fg-frontend/plugins/edeeshop-popup/EdeeshopPopup';

EdeeshopPopup.prototype._handleNavigation = function(trigger, eventType) {
  window.edeeshopPopup.close();
};
$('body').on('click', '.js_esp-trigger[data-esp="navigation-refresh"]', (e) => EdeeshopPopup.prototype._handleNavigation(e, e.type));




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EdeeshopNavigationRefresh.js